import React, { useEffect } from 'react';
import styles from './AdminSinglePage.module.scss';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import InputCustom from '../../../components/admin/InputCustom/InputCustom';
import { Box, Button, CircularProgress } from '@mui/material';
import PrevImage from '../../../components/admin/PrevImage/PrevImage';
import Loading from '../../../components/admin/Loading/Loading';
import GalleryImage from '../../../components/admin/GalleryImage/GalleryImage';
import DeleteBtn from '../../../components/admin/DeleteBtn/DeleteBtn';
import UploadImage from '../../../components/admin/UploadImage/UploadImage';
const AdminSinglePage = ({ reset, onSubmit = () => {}, fields, onFormatData, fetch, sliceName, actionName, isSave, propName, type, pathList, deleteProps = {}, blockProps = {}, unblockProps = {}, isDelete = true, isBlock = true, isCreate }) => {
  const form = useForm();
  const { id } = useParams();
  const disaptch = useDispatch();
  useEffect(() => {
    if (id && !isCreate) {
      disaptch(fetch({ id }));
    }
  }, [id]);
  useEffect(() => {
    return () => {
      disaptch(reset());
    };
  }, []);

  const selector = useSelector((state) => state[sliceName]);
  const selectorData = selector[actionName];
  const data = selectorData?.data;
  const loading = selectorData?.loading;
  const navigate = useNavigate();
  useEffect(() => {
    if (data) {
      const formData = onFormatData(data);

      Object.entries(formData).forEach(([field, value]) => {
        form.setValue(field, value, { shouldValidate: true });
      });
    }
  }, [data]);
  console.log(form.formState.errors);

  const getInputField = ({ disabled, required = true, format, rules = {}, label, name, type, options, render }) => {
    switch (type) {
      case 'text':
        return <InputCustom disabled={disabled} required={required} rules={rules} form={form} name={name} label={label} />;
      case 'textarea':
        return <InputCustom isTextarea disabled={disabled} required={required} rules={rules} form={form} name={name} label={label} />;
      case 'image':
        return <PrevImage form={form} name={name} label={label} />;
      case 'upload':
        return <UploadImage form={form} name={name} label={label} size="100%" />;
      case 'gallery':
        return <GalleryImage form={form} name={name} label={label} />;
      case 'radio':
        return <InputCustom options={options} isRadio form={form} name={name} label={label} />;
      case 'title':
        return <Box sx={{ mb: '8px', fontWeight: '600' }}>{label}</Box>;
      case 'select':
        return <InputCustom isSelect options={options} form={form} name={name} label={label} disabled={disabled} />;
      case 'date':
        return <InputCustom isDate form={form} name={name} label={label} />;
      case 'time':
        return <InputCustom isTime form={form} name={name} label={label} required={required} />;
      case 'number':
        return <InputCustom disabled={disabled} format={format} isNumber form={form} name={name} label={label} required={required} />;
      case 'checkbox':
        return <InputCustom isCheckbox options={options} format={format} form={form} name={name} label={label} />;
      case 'custom':
        return render ? render({ form, getInputField }) : null;
      default:
        break;
    }
  };
  if (loading && !isCreate) {
    return <CircularProgress sx={{ display: 'block', margin: '0 auto', mt: 4 }} />;
  }
  if (!data && !isCreate) {
    return <></>;
  }
  return (
    <Box>
      <Box sx={{ display: 'grid', rowGap: 2 }}>
        {' '}
        {fields?.map((item) =>
          Array.isArray(item) ? (
            <Box sx={{ display: 'grid', gap: 1, gridTemplateColumns: item?.[0]?.grid ?? `repeat(${item?.length},1fr)`, alignItems: 'start' }}>
              {item?.map((subitem) =>
                Array.isArray(subitem) ? (
                  <Box sx={{ display: 'grid', gap: 1 }}>
                    {subitem?.map((subsubitem) => (
                      <Box sx={{ ...(subitem?.width && { width: subitem?.width }) }}>{getInputField(subsubitem)}</Box>
                    ))}
                  </Box>
                ) : (
                  <Box sx={{ ...(subitem?.width && { width: subitem?.width }) }}>{getInputField(subitem)}</Box>
                ),
              )}
            </Box>
          ) : (
            <Box sx={{ ...(item?.width && { width: item?.width }) }}> {getInputField(item)}</Box>
          ),
        )}
      </Box>
      <Box sx={{ mt: 10, display: 'flex', alignItems: 'center', justifyContent: 'end', gap: 1 }}>
        {isDelete && (
          <DeleteBtn
            {...deleteProps}
            type={type}
            id={id}
            onDelete={() => {
              navigate(pathList);
            }}
          />
        )}
        {isBlock && (
          <>
            {data?.[propName]?.status == 'ACTIVE' ? (
              <DeleteBtn
                {...blockProps}
                type={type}
                id={id}
                onDelete={() => {
                  navigate(pathList);
                }}
              />
            ) : (
              <DeleteBtn
                {...unblockProps}
                type={type}
                id={id}
                onDelete={() => {
                  navigate(pathList);
                }}
              />
            )}
          </>
        )}

        {isSave && (
          <>
            <Button onClick={form.handleSubmit(onSubmit)} variant="contained" sx={{ backgroundColor: 'success.light', display: 'flex' }}>
              Сохранить
            </Button>
          </>
        )}
      </Box>
    </Box>
  );
};

export default AdminSinglePage;
